<template>
  <div class="wrapper">
    <div class="row">
      <div class="col col-12 col-md-3 name">
        <div class="form-group">
          <c-input
            v-model="value.company"
            floating-label="Организация"
            :clearable="true"
            :max-length="255"
            :required="error && error.company"
            :required-message="error && error.company"
          />
        </div>
      </div>

      <div class="col col-12 col-md-3 position">
        <div class="form-group">
          <c-select
            v-model="value.position"
            type="select"
            floating-label="Должность"
            :clearable="true"
            :items="options"
            :invalid="error && !!error.position"
            :error="error && error.position"
            :custom-options="field.custom"
          />
        </div>
      </div>

      <div class="col col-6 col-md-2 salary">
        <div class="form-group">
          <c-input
            v-model="value.salary"
            floating-label="Размер зарплаты, ฿"
            :clearable="true"
            type="price-number"
            :split="true"
            :max-length="255"
          />
        </div>
      </div>

      <div class="col col-1 col-md-2 remove d-none d-md-block d-xl-none">
        <c-button
          v-if="canRemove"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Удалить',
            placement: 'top',
          }"
          size="iconic"
          icon="trash"
          @click="$emit('remove')"
        />
      </div>

      <div class="col col-12 col-md-3 period">
        <div class="form-group">
          <month-period-select
            v-model="value.period"
            floating-label="Начало — окончание работы"
            :clearable="true"
            :invalid="!!(error && error.period)"
            :error="error && error.period"
          ></month-period-select>
        </div>
      </div>

      <div class="col col-1 remove d-none d-xl-block">
        <c-button
          v-if="canRemove"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Удалить',
            placement: 'top',
          }"
          size="iconic"
          icon="trash"
          @click="$emit('remove')"
        />
      </div>

      <div class="col col-12 col-md-6 recommender">
        <div class="form-group">
          <c-input
            v-model="value.recommender"
            floating-label="Кто может вас рекомендовать"
            :clearable="true"
            :max-length="255"
          />
        </div>
      </div>

      <div class="col col-12 col-md-3 contact">
        <div class="form-group">
          <c-input v-model="value.contact" floating-label="Телефон или email" :clearable="true" :max-length="255" />
        </div>
      </div>

      <div class="col col-12 d-md-none">
        <div class="d-flex justify-content-end">
          <c-button
            v-if="canRemove"
            v-b-popover.html="{
              container: '#app',
              trigger: 'hover blur',
              content: 'Удалить',
              placement: 'top',
            }"
            size="small"
            label="Удалить"
            icon="trash"
            @click="$emit('remove')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MonthPeriodSelect from "@/components/month-period-select";
import CInput from "@/components/controls2/Input";
import CSelect from "@/components/controls2/Select";
import CButton from "@/components/controls2/Button";

export default {
  components: { MonthPeriodSelect, CInput, CSelect, CButton },
  props: ["field", "value", "error", "canRemove", "options"],
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";
@import "~@/assets/styles/grid.scss";

.wrapper {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #dfe4ef;

  @include bootstrapMd {
    padding-bottom: 0;
    border-bottom: none;
    margin-bottom: 0;

    @include gridGenerator(10);
  }

  @include bootstrapXl {
    @include gridGenerator(12);

    .period {
      /deep/ {
        .c-input-container {
          left: auto;
          right: 0;
        }
      }
    }
  }
}

.remove {
  padding-top: 20px;
}
</style>
